var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFlipImage = function SvgFlipImage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.287 6.337a.583.583 0 0 1 0 .825l-1.629 1.63H6.5a.583.583 0 0 1 0 1.166H2.658l1.63 1.63a.583.583 0 1 1-.826.824L.837 9.787a.583.583 0 0 1 0-.825l2.625-2.625a.583.583 0 0 1 .825 0Zm9.342 0a.583.583 0 0 1 .825 0l2.625 2.625a.583.583 0 0 1 0 .825l-2.625 2.625a.583.583 0 1 1-.825-.825l1.63-1.629h-3.842a.583.583 0 0 1 0-1.167h3.841L13.63 7.162a.583.583 0 0 1 0-.825Z"
  })));
};
export default SvgFlipImage;